module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "single-header",
    style: ({
      background: _vm.project.background
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.project.logo,
      "alt": _vm.project.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.project.title)), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.project.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "single-meta"
  }, [_c('div', {
    staticClass: "single-meta__chip"
  }, [_c('span', {
    staticClass: "single-meta__title",
    style: ({
      background: _vm.project.color
    })
  }, [_vm._v("\n                    Role\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "single-meta__content"
  }, [_vm._v(_vm._s(_vm.project.role))])]), _vm._v(" "), _c('div', {
    staticClass: "single-meta__chip"
  }, [_c('span', {
    staticClass: "single-meta__title",
    style: ({
      background: _vm.project.color
    })
  }, [_vm._v("\n                    Features\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "single-meta__content"
  }, [_vm._v(_vm._s(_vm.project.features))])])]), _vm._v(" "), _c('div', {
    staticClass: "single-description"
  }, [_vm._t("default"), _vm._v(" "), (_vm.project.url) ? _c('a', {
    staticClass: "btn",
    style: ({
      background: _vm.project.color
    }),
    attrs: {
      "href": _vm.project.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                Visit Site\n            ")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-946eb9f6"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/partials/single-header.vue
// module id = 109
// module chunks = 0